import { render, staticRenderFns } from "./CambiarContraseña.vue?vue&type=template&id=485a2162"
import script from "./CambiarContraseña.vue?vue&type=script&lang=js"
export * from "./CambiarContraseña.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/74a6e498-56df-5c0c-aa3e-2f5fe39d1378/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485a2162')) {
      api.createRecord('485a2162', component.options)
    } else {
      api.reload('485a2162', component.options)
    }
    module.hot.accept("./CambiarContraseña.vue?vue&type=template&id=485a2162", function () {
      api.rerender('485a2162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Views/Franquicia/CambiarContraseña.vue"
export default component.exports